import type { PrefetchableComponentType } from 'src/shared/prefetch';

import { Banner } from 'src/app/app/banner';
import { DefaultLayout } from 'src/app/app/layout';

const prefetchDependencies: readonly PrefetchableComponentType[] = [DefaultLayout, Banner];

export function getPrefetchDependencies(): readonly PrefetchableComponentType[] {
	return prefetchDependencies;
}

export { prefetchLayoutData } from 'src/app/app/layout';
